const QuestionTypes = {
    MultipleChoice: 0,
    MultipleChoiceWithText: 1,
};
  
export default QuestionTypes;